<template>
  <NuxtLoadingIndicator :throttle="500" :hide-delay="0" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
